import { useFetchedProgramTypes } from './useFetchedProgramTypes';
import { isSocialPostingProgramType } from '../util';

export const useSocialPostProgramType = () => {
  const { data: programTypes } = useFetchedProgramTypes();
  const socialPostProgramType = programTypes
    ? programTypes.types.find(isSocialPostingProgramType)
    : null;
  return socialPostProgramType ? socialPostProgramType : null;
};
